
const SET_PROFILE_MEDIA_ITEM = 'SET_PROFILE_MEDIA_ITEM';
const SET_COVER_MEDIA_ITEM = 'SET_COVER_MEDIA_ITEM';
const SET_MEDIA_ITEMS = 'SET_MEDIA_ITEMS';
const SET_NEXT_MEDIA_ITEMS_CURSOR = 'SET_NEXT_MEDIA_ITEMS_CURSOR';
const LOAD_MORE_MEDIA_ITEMS = 'LOAD_MORE_MEDIA_ITEMS';
const SET_CUSTOMER_MEDIA_ITEMS = 'SET_CUSTOMER_MEDIA_ITEMS';
const LOAD_MORE_CUSTOMER_MEDIA_ITEMS = 'LOAD_MORE_CUSTOMER_MEDIA_ITEMS';
const SET_NEXT_CUSTOMER_MEDIA_ITEMS_CURSOR = 'SET_NEXT_CUSTOMER_MEDIA_ITEMS_CURSOR';
const RESET_STATE = 'RESET_STATE';
const SET_ADD_MEDIA_MODAL_OPEN = 'SET_ADD_MEDIA_MODAL_OPEN';
const DELETE_MEDIA_ITEM = 'DELETE_MEDIA_ITEM';
const SET_MEDIA_ITEM_PREVIEW_MODAL_OPEN = 'SET_MEDIA_ITEM_PREVIEW_MODAL_OPEN';
const SET_MEDIA_ITEM_PREVIEW_SOURCE = 'SET_MEDIA_ITEM_PREVIEW_SOURCE';

const state = {
  profileMediaItem: null,
  coverMediaItem: null,
  mediaItems: null,
  nextMediaItemsCursor: null,
  customerMediaItems: null,
  nextCustomerMediaItemsCursor: null,
  addMediaModalOpen: false,
  mediaItemPreviewModalOpen: false,
  mediaItemPreviewSource: '/assets/images/login-bg.jpg',
  mediaValidationErrors: {
    'mediaItem': [],
  }
};

const getters = {
  profileMediaItem({ profileMediaItem }) {
    return profileMediaItem;
  },
  coverMediaItem({ coverMediaItem }) {
    return coverMediaItem;
  },
  mediaItems({ mediaItems }) {
    return mediaItems;
  },
  nextMediaItemsCursor({ nextMediaItemsCursor }){
    return nextMediaItemsCursor;
  },
  customerMediaItems({ customerMediaItems }) {
    return customerMediaItems;
  },
  nextCustomerMediaItemsCursor({ nextCustomerMediaItemsCursor }){
    return nextCustomerMediaItemsCursor;
  },
  isInViewport: (state) => (element) => {
    if (!element) {
      return false;
    }
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  },
  addMediaModalOpen({ addMediaModalOpen }) {
    return addMediaModalOpen;
  },
  mediaItemPreviewModalOpen({ mediaItemPreviewModalOpen }) {
    return mediaItemPreviewModalOpen;
  },
  mediaItemPreviewSource({ mediaItemPreviewSource }) {
    return mediaItemPreviewSource;
  }
};

const actions = {
  fetchAllMediaItems({ dispatch }, id) {
    dispatch('fetchProfileMediaItem', id);
    dispatch('fetchCoverMediaItem', id);
    dispatch('fetchMediaItems', id);
    dispatch('fetchCustomerMediaItems', id);
  },
  fetchProfileMediaItem({ commit }, id) {
    return axios.get( `/gbp/get-profile-media-item/${id}`)
      .then(({ data }) => {
        commit(SET_PROFILE_MEDIA_ITEM, data.mediaItem);
      }).catch(error => {
        // TODO: decide on error handling
      });
  },
  fetchCoverMediaItem({ commit }, id) {
    return axios.get( `/gbp/get-cover-media-item/${id}`)
      .then(({ data: response }) => {
        commit(SET_COVER_MEDIA_ITEM, response.mediaItem);
      }).catch(error => {
        // TODO: decide on error handling
      });
  },
  fetchMediaItems({ commit, getters }, id) {
    return axios.get( `/gbp/get-media-items/${id}`)
      .then(({ data }) => {
        const {data: mediaItems, next_cursor} = data;
        commit(SET_MEDIA_ITEMS, mediaItems);
        commit(SET_NEXT_MEDIA_ITEMS_CURSOR, next_cursor);
      }).catch(error => {
        // TODO: decide on error handling
    });
  },
  fetchMoreMediaItems({ commit, getters }, id) {
    const cursor = getters.nextMediaItemsCursor;
    return axios.get( `/gbp/get-media-items/${id}?cursor=${cursor}`)
      .then(({ data }) => {
        const {data: mediaItems, next_cursor} = data;
        commit(LOAD_MORE_MEDIA_ITEMS, mediaItems);
        commit(SET_NEXT_MEDIA_ITEMS_CURSOR, next_cursor);
      }).catch(error => {
        // TODO: decide on error handling
      });
  },
  fetchCustomerMediaItems({ commit, getters }, id) {
    return axios.get( `/gbp/get-customer-media-items/${id}`)
      .then(({ data }) => {
        const {data: mediaItems, next_cursor} = data;
        commit(SET_CUSTOMER_MEDIA_ITEMS, mediaItems);
        commit(SET_NEXT_CUSTOMER_MEDIA_ITEMS_CURSOR, next_cursor);
      }).catch(error => {
        // TODO: decide on error handling
    });
  },
  fetchMoreCustomerMediaItems({ commit, getters }, id) {
    const cursor = getters.nextCustomerMediaItemsCursor;
    return axios.get( `/gbp/get-customer-media-items/${id}?cursor=${cursor}`)
      .then(({ data }) => {
        const {data: mediaItems, next_cursor} = data;
        commit(LOAD_MORE_CUSTOMER_MEDIA_ITEMS, mediaItems);
        commit(SET_NEXT_CUSTOMER_MEDIA_ITEMS_CURSOR, next_cursor);
      }).catch(error => {
        // TODO: decide on error handling
      });
  },
  clearAllMedia({ commit }) {
    commit(RESET_STATE);
  },
  openAddMediaModal({ commit }) {
    commit(SET_ADD_MEDIA_MODAL_OPEN, true);
  },
  closeAddMediaModal({ commit }) {
    // TODO: ideally Modal component needs to catch emits from slots. See scoped slots on vue docs
    document.body.style.position = '';
    commit(SET_ADD_MEDIA_MODAL_OPEN, false);
  },
  deleteMediaItem({ commit }, { id, mediaItemId}) {
    return new Promise((resolve, reject) => {
      axios.post(`/gbp/delete-media-item/${id}`, {
        mediaItemId
      }).then(response => {
        commit(DELETE_MEDIA_ITEM, mediaItemId);
        resolve();
      }).catch(({ response }) => {
        reject(response.data.message);
        // TODO: decide on error handling
      });
    });
  },
  openMediaItemPreviewModal({ commit }, source) {
    commit(SET_MEDIA_ITEM_PREVIEW_MODAL_OPEN, true);
    commit(SET_MEDIA_ITEM_PREVIEW_SOURCE, source);
  },
  closeMediaItemPreviewModal({ commit }) {
    commit(SET_MEDIA_ITEM_PREVIEW_MODAL_OPEN, false);
    commit(SET_MEDIA_ITEM_PREVIEW_SOURCE, null);
  }
};

const mutations = {
  [SET_PROFILE_MEDIA_ITEM](state, profileMediaItem) {
    state.profileMediaItem = profileMediaItem;
  },
  [SET_COVER_MEDIA_ITEM](state, coverMediaItem) {
    state.coverMediaItem = coverMediaItem;
  },
  [SET_MEDIA_ITEMS](state, mediaItems) {
    state.mediaItems = mediaItems;
  },
  [LOAD_MORE_MEDIA_ITEMS](state, mediaItems) {
    let merge = state.mediaItems;
    merge.push(...mediaItems);
    state.mediaItems = merge;
  },
  [SET_NEXT_MEDIA_ITEMS_CURSOR](state, cursor) {
    state.nextMediaItemsCursor = cursor;
  },
  [SET_CUSTOMER_MEDIA_ITEMS](state, customerMediaItems) {
    state.customerMediaItems = customerMediaItems;
  },
  [LOAD_MORE_CUSTOMER_MEDIA_ITEMS](state, customerMediaItems) {
    let merge = state.customerMediaItems;
    merge.push(...customerMediaItems);
    state.customerMediaItems = merge;
  },
  [SET_NEXT_CUSTOMER_MEDIA_ITEMS_CURSOR](state, cursor) {
    state.nextCustomerMediaItemsCursor = cursor;
  },
  [RESET_STATE](state) {
    state.profileMediaItem = null;
    state.coverMediaItem = null;
    state.mediaItems = null;
    state.nextMediaItemsCursor = null;
    state.customerMediaItems = null;
    state.nextCustomerMediaItemsCursor = null;
    state.addMediaModalOpen = false;
  },
  [SET_ADD_MEDIA_MODAL_OPEN](state, bool) {
    state.addMediaModalOpen = bool;
  },
  [DELETE_MEDIA_ITEM](state, mediaItemId) {
    const index = state.mediaItems.findIndex(mediaItem => mediaItem.id === mediaItemId);
    state.mediaItems.splice(index, 1);
  },
  [SET_MEDIA_ITEM_PREVIEW_MODAL_OPEN](state, bool) {
    state.mediaItemPreviewModalOpen = bool;
  },
  [SET_MEDIA_ITEM_PREVIEW_SOURCE](state, source) {
    state.mediaItemPreviewSource = source;
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};
